<template>
  <div class="tile_container container">
    <Tile title="Edit tile" :startUpAnimation="false">
      <Notification :type="n_type" :message="n_message" />
      <form @submit="submitEditTile" ref="edit_tile">
        <div id="general" style="text-align:left;">
          <h4>General</h4>
          <input type="text" readonly v-model="tile" />
          <input type="text" placeholder="Title of tile" id="title" v-model="form.title" />
        </div>
        <div id="rules" style="text-align:left;">
          <h4>Rules</h4>
          <RuleComponent
            v-for="(rule, index) in rules"
            :key="rule"
            :index="index"
            :existing_data="rule.type == 'time' ? rule.time : rule.location"
            :type="rule.type"
            @onDeleteRule="deleteRule"
          />
          <div class="row">
            <div class="col-sm-4">
            <button type="button" @click="addTimeRule" style="width: 100%;">
              <i class="fal fa-clock" style="font-size:23px;"></i>
              <span style="margin-left: 30px;">Add time</span>
            </button>
            </div>
            <div class="col-sm-4">
              <button type="button" @click="addLocationRule" style="width: 100%;">
                <i class="fal fa-location" style="font-size:23px;"></i>
                <span style="margin-left: 30px;">Add location</span>
              </button>
            </div>
            <div class="col-sm-4">
              <select v-model="rule_settings.match_type">
                <option value="one">Match just one</option>
                <option value="all">Match all</option>
              </select>
            </div>
          </div>
        </div>
        <div id="optional_settings" style="text-align:left;" v-if="settings.length > 0">
          <h4>Settings</h4>
          <SettingComponent
            v-for="setting in settings"
            :key="setting.name"
            :tile_path="form.path"
            :type="setting.type"
            :name="setting.name"
            :label="setting.label"
            :placeholder="setting.placeholder"
            :required="setting.required"
            :oauth_settings="{
                type: setting.oauth_type,
                code_url: setting.oauth_auth_code_url,
                token_url: setting.oauth_auth_token_url,
                additional_parameters: setting.oauth_additional_parameters,
                scope: setting.scope,
                scope_delimiter: setting.scope_delimiter,
                client_id: setting.client_id,
                client_secret: setting.client_secret
              }"
            :value="JSON.parse(form.settings)[setting.name]"
          />
        </div>
        <button type="submit" style="width:50%;">
          <i class="fal fa-save" style="font-size:23px;"></i>
          <span style="margin-left: 30px;">Save</span>
        </button>
      </form>
    </Tile>
  </div>
</template>

<script>
import axios from "axios";
import Config from "../config";
import { storage, auth } from "../schmucklicloud";

export default {
  data() {
    return {
      id: 0,
      form: {},
      settings: [],
      rules: [],
      rule_settings: {
        match_type: 'one'
      },

      n_type: "",
      n_message: ""
    };
  },
  mounted() {
    var session_token = window.localStorage.getItem("session_token");
    auth.checkSession(session_token).then(function(response){
        if (!response.isOK) {
            this.$router.replace("/login");
        } else {
          this.id = this.$route.params.id;
          this.loadTileInformation(this.id);
        }
    }.bind(this));
  },
  computed: {
    tile() {
      return this.form.title + " (" + this.form.path + ")";
    }
  },
  methods: {
    loadTileInformation(id) {
      storage.getById("tiles", id).then(
        function(response) {
          if (response.isOK) {
            this.form = response.data.data;
            this.rules = this.form.rules ? JSON.parse(this.form.rules) : [];
            this.rule_settings = this.form.rule_settings ? JSON.parse(this.form.rule_settings) : this.rule_settings;
            axios.get(Config.DASHBOARD_API_ENDPOINT + "config.php").then(
              function(response) {
                if (response.status === 200) {
                  response.data.tiles.forEach(
                    function(tile) {
                      if (tile.path === this.form.path) {
                        if(tile.settings !== undefined) {
                          this.settings = tile.settings;
                        }
                      }
                    }.bind(this)
                  );
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    submitEditTile(e) {
      e.preventDefault();

      var rules = [];
      var settings = {};

      //Fetch the rules
      if (this.rules !== undefined && this.rules.length > 0) {
        this.rules.forEach(function(rule, index) {
          switch(rule.type) {
            case "time":
              var from = this.$refs.edit_tile["rule_" + index + "_time_from"].value;
              var to = this.$refs.edit_tile["rule_" + index + "_time_to"].value;

              rule["time"] = {};
              rule["time"]["from"] = parseInt(from);
              rule["time"]["to"] = parseInt(to);
              rules.push(rule);
              break;
            case "location":
              var lat = this.$refs.edit_tile["rule_" + index + "_location_lat"].value;
              var lon = this.$refs.edit_tile["rule_" + index + "_location_lon"].value;
              var radius = this.$refs.edit_tile["rule_" + index + "_location_radius"].value;

              rule["location"] = {};
              rule["location"]["lat"] = parseFloat(lat);
              rule["location"]["lon"] = parseFloat(lon);
              rule["location"]["radius"] = parseFloat(radius);
              rules.push(rule);
              break;
          }
        }.bind(this));
      }

      this.form.rules = JSON.stringify(rules);
      this.form.rule_settings = JSON.stringify(this.rule_settings);

      //Fetch the settings
      if (this.settings !== undefined && this.settings.length > 0) {
        this.settings.forEach(
          function(setting) {
            var value = this.$refs.edit_tile["setting_" + setting.name].value;
            settings[setting.name] = value;
          }.bind(this)
        );
      }

      this.form.settings = JSON.stringify(settings);

      storage.update("tiles", this.id, this.form).then(
        function(response) {
          if (response.isOK) {
            this.$router.replace({ name: "TileManagement" });
          } else {
            this.n_type = "error";
            this.n_message = response.message;
          }
        }.bind(this)
      );
    },
    addTimeRule() {
      this.$set(this.rules, this.rules.length, {
        type: "time"
      });
    },
    addLocationRule() {
      this.$set(this.rules, this.rules.length, {
        type: "location"
      });
    },
    deleteRule(index) {
      this.$set(this.rules, index, {});
      this.rules = this.rules.filter(value => Object.keys(value).length !== 0);
    }
  }
};
</script>
<style>
#optional_settings, #rules, #general {
  margin-bottom: 60px;
}
button {
  cursor: pointer;
}
</style>